import { IStyle, classNamesFunction } from '@fluentui/react';
export interface IRequestCreationStyles {
  businessAssistRequestFormContainer: IStyle;
}

export interface IRequestCreationStylesProps {
  isNonAgave: boolean;
}

export const getRequestCreationStyles = (props: IRequestCreationStylesProps): IRequestCreationStyles => {
  const {isNonAgave} = props;
  return {
    businessAssistRequestFormContainer: {
      width: !isNonAgave ? '50%' : 'auto',
    },
  };
};

export const getRequestCreationClassNames = classNamesFunction<{}, IRequestCreationStyles>();
